/* history Swiper */
$(() => {
	$('.js-history-dates').on('click','a', function (event) {
		event.preventDefault();

		var id  = $(this).attr('href'),
			top = 0;

		top = $(id).position().top;
		$('.js-history-main').animate({scrollTop: top + 1}, 500);

		var left = 0;
		left = $(this).position().left + $('.history-dates__inner').scrollLeft() - 30;
		$('.history-dates__inner').animate({scrollLeft: left}, 500);
	});

	$('.js-history-arrow-down').on('click', function(){
		$('.js-history-dates').find('.active').next().click();
	});

	$('.history-main__img-link').magnificPopup({type:'image'});

	$('.js-history-main').scroll(function(){
		$('.history-main__slide').each(function(index){
			var attr = $(this).attr('id');

			if (Math.round($(this).offset().top) <= $('.js-history-main').offset().top) {
				var attr = $(this).attr('id');

				$('.js-history-dates').find('a.active').removeClass('active');
				$('.js-history-dates').find('a[href="#'+ attr +'"]').addClass('active');

				var left = 0;
				left = $('.js-history-dates').find('a[href="#'+ attr +'"]').position().left + $('.history-dates__inner').scrollLeft() - 0;
				$('.history-dates__inner').animate({scrollLeft: left}, 0);
			}
		});
	});
});


// WEBPACK FOOTER //
// ./src/scripts/components/sliders/history-slider.js